'use strict';

angular.module('licensure.services')
    .factory('VehicleSpecialties', ['$http', '$q', function ($http, $q) {
        return {
            get: function () {
                var d = $q.defer();

                $http.get(apiLocation + '/api/vehiclespecialties', {
                    params: {
                        
                    }
                })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    console.log(response.data);
                    // handle error
                });

                return d.promise; 
            }
        }
    }])
;